import React, { useState, useEffect } from "react";
import logo from "../../../../../assets/fe-images/logo.png";
import { Link } from "react-router-dom";

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "Features", section: "features" },
    { label: "How It Works", section: "how-it-works" },
    { label: "MeetOcto For", section: "meetocto-for" },
    { label: "Pricing", section: "pricing" },
    { label: "FAQ", section: "faq" },
  ];

  return (
    <nav className={`landing-nav${scrolled ? " landing-nav--scrolled" : ""}`}>
      <div className="landing-nav__container">
        <div className="landing-nav__logo">
          <img src={logo} alt="MeetOcto" />
        </div>

        <ul className={`landing-nav__links${menuOpen ? " landing-nav__links--open" : ""}`}>
          {navLinks.map((link) => (
            <li key={link.section}>
              <button
                className="landing-nav__link-btn"
                onClick={() => {
                  scrollToSection(link.section);
                  setMenuOpen(false);
                }}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        <div className="landing-nav__actions">
          <Link to="/admin/login">
            <button className="landing-nav__btn landing-nav__btn--login">Log In</button>
          </Link>
          <Link to="/signup">
            <button className="landing-nav__btn landing-nav__btn--signup">Get Started</button>
          </Link>
        </div>

        <button
          className={`landing-nav__hamburger${menuOpen ? " landing-nav__hamburger--open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {menuOpen && (
        <div className="landing-nav__mobile-menu">
          {navLinks.map((link) => (
            <button
              key={link.section}
              className="landing-nav__mobile-link"
              onClick={() => {
                scrollToSection(link.section);
                setMenuOpen(false);
              }}
            >
              {link.label}
            </button>
          ))}
          <div className="landing-nav__mobile-actions">
            <Link to="/admin/login" onClick={() => setMenuOpen(false)}>
              <button className="landing-nav__btn landing-nav__btn--login">Log In</button>
            </Link>
            <Link to="/signup" onClick={() => setMenuOpen(false)}>
              <button className="landing-nav__btn landing-nav__btn--signup">Get Started</button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};
